import './ReferralQuestion.scss'

import React, {Component} from 'react'
import {
  TITLE_WILL_YOU_SELECT_CHOICES, ANSWER_TYPE, QUALIA_QUESTIONS, QUESTION_TYPE,
} from 'common/constants'
import cx from 'classnames'
import {connect} from 'react-redux'
import {createStructuredSelector} from "reselect"


import {selectTitleWillYouSelectQuestion, selectTransactionType} from "manager/selectors/referral_selectors"
import {updateAgentTitleQuestions} from "manager/redux/referral"

class ReferralQuestionTitleWillYouSelect extends Component {
  state = {
    choices: [],
    subtitle: null,
    question: null,
  }

  componentDidMount() {
    const {transactionType, editStatus, titleWillYouSelectAnswer, updateAgentTitleQuestions} = this.props

    const includeNotSureButton = QUALIA_QUESTIONS[editStatus][QUESTION_TYPE.TITLE_WILL_YOU_SELECT]['not-sure-button']
    if (!includeNotSureButton && titleWillYouSelectAnswer && titleWillYouSelectAnswer[ANSWER_TYPE.YES_NO] === 'not-sure'){
      updateAgentTitleQuestions({[QUESTION_TYPE.TITLE_WILL_YOU_SELECT]: null})
    }
    const subtitle = QUALIA_QUESTIONS[editStatus][QUESTION_TYPE.TITLE_WILL_YOU_SELECT]['subtitle']
    const question = QUALIA_QUESTIONS[editStatus][QUESTION_TYPE.TITLE_WILL_YOU_SELECT]['question']
    const noButtonText = QUALIA_QUESTIONS[editStatus][QUESTION_TYPE.TITLE_WILL_YOU_SELECT]['no-button-text']
    let type = 'buy'
    if (transactionType === 'buy'){
      type = 'sell'
    }
    let choices = TITLE_WILL_YOU_SELECT_CHOICES({type, noButtonText})
    if (!includeNotSureButton){
      choices = choices.filter(item => item.value !== 'not-sure')
    }
    this.setState({choices, subtitle, question})
  }

  handleOnClick = (value) => {
    const {updateAgentTitleQuestions} = this.props
    updateAgentTitleQuestions({[QUESTION_TYPE.TITLE_WILL_YOU_SELECT]: {[ANSWER_TYPE.YES_NO]: value}})
  }

  render() {
    const {titleWillYouSelectAnswer} = this.props
    const {choices, subtitle, question} = this.state
    return (
      <div className="ReferralQuestion">
        <div className="subtitle">{subtitle}</div>
        <div className="question">{question}</div>
        <div className="choice-btns">
          {choices.map(({label, value}) => (
            <button
              key={value}
              onClick={() => this.handleOnClick(value)}
              className={cx('StatusChoice', {
                'StatusChoice__selected': titleWillYouSelectAnswer && titleWillYouSelectAnswer[ANSWER_TYPE.YES_NO] === value
              })}>
              {label}
            </button>
          ))}
        </div>
      </div>
    )
  }

}

const selector = createStructuredSelector({
  titleWillYouSelectAnswer: selectTitleWillYouSelectQuestion,
  transactionType: selectTransactionType,
})

const actions = {
  updateAgentTitleQuestions
}

export default connect(selector, actions)(ReferralQuestionTitleWillYouSelect)
